export function invalidRoute(path) {
  return `${path}`
}
